var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoCirclePurple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1909 13.463C11.2024 13.8679 11.5339 14.1901 11.9389 14.1901C12.344 14.1901 12.6755 13.8679 12.687 13.463L12.8596 7.39175C12.8743 6.87305 12.4578 6.44458 11.9389 6.44458C11.42 6.44458 11.0036 6.87305 11.0183 7.39175L11.1909 13.463ZM10.8892 16.5177C10.8892 17.091 11.3539 17.5557 11.9271 17.5557H11.9507C12.524 17.5557 12.9887 17.091 12.9887 16.5177C12.9887 15.9444 12.524 15.4797 11.9507 15.4797H11.9271C11.3539 15.4797 10.8892 15.9444 10.8892 16.5177Z",
    fill: "#492897"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.58312,
    y: 1.58336,
    width: 20.8333,
    height: 20.8333,
    rx: 10.4167,
    stroke: "#492897",
    strokeWidth: 1.38889
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCirclePurple);
export default __webpack_public_path__ + "static/media/info_circle_purple.c6d543111d67bd91117d5ccfa252128e.svg";
export { ForwardRef as ReactComponent };